import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const LeaveConversationModal = ({ open, onClose, onConfirm, visitorName = '' }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const desc = visitorName
    ? (t('live_inbox_leave_modal_desc_name') || 'Are you sure you want to leave this conversation with {{name}}? The visitor will be notified that you\u2019ve left.').replace('{{name}}', visitorName)
    : (t('live_inbox_leave_modal_desc') || 'Are you sure you want to leave this conversation? The visitor will be notified that you\u2019ve left.');

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          padding: isMobile ? '20px' : '30px',
          width: isMobile ? '80%' : '90%',
          maxWidth: 400,
        }}
      >
        <h2 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: 600 }}>
          {t('live_inbox_leave_modal_title') || 'Leave conversation?'}
        </h2>
        <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#6b7280', lineHeight: 1.5 }}>
          {desc}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: '#5616ea',
              borderColor: '#5616ea',
              '&:hover': {
                borderColor: '#5e0fb3',
                backgroundColor: '#f3eaff',
              },
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#dc2626',
              '&:hover': {
                backgroundColor: '#b91c1c',
              },
            }}
          >
            {t('live_inbox_leave_modal_confirm') || 'Leave chat'}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default LeaveConversationModal;
